import {Component, OnDestroy, OnInit} from '@angular/core';
import {GenericDatatableComponent} from '../../../shared/components/generic-datatable/generic-datatable.component';
import {select} from '@ngrx/store';
import * as fromRoot from '../../../shared/reducers';
import {SetPreferencesAction} from '../../../shared/actions/preferences';
import {OrderItem} from '../../../order/models/order-item';
import {LinkContractModalComponent} from '../../../shared/components/link-contract-modal/link-contract-modal.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {filter, map} from 'rxjs/operators';
import {MenuItem} from '../../../shared/models/context-menu-data';
import {CloseBillingSubscriptionComponent} from '../../../shared/components/close-billing-subscription/close-billing-subscription.component';
import {SelectedItem} from '../../../order/models/order';
import * as fromCompanies from '../../../company/reducers';
import {
  ChangeSubListPageSizeAction, ClearALLSubListAction,
  ClearSubListAction,
  ExportAnomalyTaskAction, ExportClientSubscriptionAction,
  ExportExcelAllSubAction,
  LoadSubAnomalyListAction,
  LoadSubByClientListAction, LoadSubByContractListAction,
  LoadSubListAction, LoadSubMultiListAction,
  OrderSubListByAction,
  PageSubListToAction,
  QuickSearchSubListAction,
  SearchSubListAction,
  SelectOneItemSubListAction,
  SelectSubListPageAction,
  SelectSubListPageSiteContextAction, SendEmailFinanceAction,
  ToggleSearchSubListAction,
  ToggleSubListSelectionAction
} from '../../actions/subscription-list';
import {ManuallyCloseOrderComponent} from '../manually-close-order/manually-close-order.component';
import * as _ from 'lodash';
import {LoadProductsCompleteListAction} from '../../actions/product-complete-list';
import * as fromShared from '../../reducers';
import * as moment from 'moment';
import {AnomalyPlayerReturnComponent} from '../anomaly-player-return/anomaly-player-return.component';
import {ModalComponent} from '@storever/modal-confirmation';
import {combineLatest} from 'rxjs';
import {IsSfInvoicedAction} from '../../actions/client-is-sf-invoiced';
import {ModalEditSfProjectComponent} from '../modal-edit-sf-project/modal-edit-sf-project.component';
import {MergeSiteDialogComponent} from '../merge-site-dialog/merge-site-dialog.component';
import {InvoicesManagementModalComponent} from '../invoices-management-modal/invoices-management-modal.component';

@Component({
  selector: 'storever-subscription-list',
  templateUrl: '../../../shared/components/generic-datatable/generic-datatable.component.html',
  styleUrls: ['../../../shared/components/generic-datatable/generic-datatable.component.scss']
})
export class SubscriptionListComponent extends GenericDatatableComponent implements OnInit, OnDestroy {
  private currentContractName: string;
  dataContext: {context: string, clientId: string, siteId: string, shippingId: string};
  companyName: string;
  companyUuid: string;
  bsModalRef: BsModalRef;
  storeCurrentClient: string;
  // tslint:disable-next-line:no-any
  roles: any;


  ngOnInit(): void {
    this.roles$ = this.storeRoot.pipe(select(fromShared.selectors.getMyRoles));
    if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
      this.isInRole();
    }

    // this.dataConfig = this.companyDataService.getSubListData().dataTabs[0].dataConfig;
    super.ngOnInit();
    if (this.router.url.split('?')[0].split('/')[1] !== 'anomalies') {
      this.loadDataOnChangeUrl('subscriptionName', 'company_sub_row_sizee');
    } else {
      this.loadDataOnChangeUrl('Name', 'company_sub_row_sizee');
    }
    this.initMenuItem();
    this.initCurrentClient();
    this.storeRoot.dispatch(new LoadProductsCompleteListAction());
  }

  isInRole(): void {
    this.roles$.subscribe(roles => {
        if (roles.length > 0) {
          this.roles = roles;
          let index;
          index = _.findIndex(roles, ['code', 'BO_BILLING_VIEW']);
          if (index === -1) {
            if (-1 !== _.findIndex(this.roles, ['code', 'BO_SETUP'])) {
              this.dataConfig = this.siteDataService.getCompanySubListDataRole().dataTabs[0].dataConfig;
             } else {
              this.dataConfig = this.siteDataService.getCompanySubListDataRole2().dataTabs[0].dataConfig;
            }
          } else {
            this.dataConfig = this.siteDataService.getCompanySubListData().dataTabs[0].dataConfig;
          }
          if (this.router.url.split('?')[0].search('multi') !== -1) {
            this.dataConfig = this.siteDataService.getSiteDetailsMultiData().dataTabs[0].dataConfig;
          }
        }
      }
    );
  }
  initCurrentClient(): void {
    this.sub$ = this.storeRoot.pipe(
      select(fromRoot.selectors.getCurrentClient),
      filter(client => client != undefined)
    ).subscribe(( client => {
      if (client) {
        this.storeCurrentClient = client.uuid;
      }
    }));
  }
  ngOnDestroy(): void {
    this.storeRoot.dispatch(new ClearALLSubListAction());
    this.dataConfig.form.markAsPristine();
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  loadData(): void {
    if (this.router.url.split('?')[0].split('/')[1] === 'anomalies') {
      this.storeRoot.dispatch(new LoadSubAnomalyListAction());
    } else if (this.router.url.split('?')[0].split('/')[2] === 'sites' && this.router.url.split('?')[0].search('multi') === -1) {
      this.storeRoot.dispatch(new LoadSubByClientListAction());
    } else if (this.router.url.split('?')[0].split('/')[2] === 'contracts') {
      this.storeRoot.dispatch(new LoadSubByContractListAction());
    } else if (this.router.url.split('?')[0].search('multi') !== -1) {
      this.storeRoot.dispatch(new LoadSubMultiListAction());
    }
    else {
      this.storeRoot.dispatch(new LoadSubListAction());
    }
  }

  storeSelect(): void {
    this.pageSize$ = this.storeRoot.pipe(select(fromRoot.selectors.getPreferencesByName, 'company_sub_row_sizee'));
    this.count$ = this.storeRoot.pipe(select(fromRoot.selectors.getSubListCount));
    this.showFilter$ = this.storeRoot.pipe(select(fromRoot.selectors.getSubListShowFilter));
    this.selectedItem$ = this.storeRoot.pipe(select(fromRoot.selectors.getSelectedSubList));
    // let pageSizeInit = true ;
    // this.sub$ = this.pageSize$.subscribe(pageSize => {
    //   if ( pageSizeInit && pageSize ) {
    //     this.storeShipping.dispatch(new ChangeSubListPageSizeAction(pageSize));
    //     pageSizeInit = false;
    //   }
    // });
    // this.subscriptions.push(this.sub$);
    this.data$ = this.storeRoot.pipe(select(fromRoot.selectors.getSubList)).pipe(
      map(data => data.filter(r => {
        this.initMenuItem();
        if (!this.currentContractName || r.contractName === this.currentContractName) {
          return r;
        }
        return;
      })),
    );
  }

  orderByChanged(orderBy: string): void {
    this.storeRoot.dispatch(new OrderSubListByAction(orderBy));
  }

  pageSizeChanged(pageSize: number): void {
    this.storeRoot.dispatch(new SetPreferencesAction({ name: 'company_sub_row_size', value: '' + pageSize }));
    this.storeShipping.dispatch(new ChangeSubListPageSizeAction(pageSize));
  }

  pageChanged(page: number): void {
    this.storeShipping.dispatch(new PageSubListToAction(page));
  }

  // tslint:disable-next-line:no-any
  applyFilter(filterForm: any): void {
    let countryCode;
    if (filterForm && filterForm.countryCode && filterForm.countryCode.code) {
      countryCode = filterForm.countryCode.code;
      filterForm.countryCode = countryCode;
    }
    this.storeRoot.dispatch(new SearchSubListAction(this.filterDeleteIfNilService.flatten(filterForm)));
  }

  applyQuickFilter(query: string): void {
    this.storeRoot.dispatch(new QuickSearchSubListAction(query));
  }

  toggleFilter(showFilter: boolean): void {
    this.storeRoot.dispatch(new ToggleSearchSubListAction(!showFilter));
  }

  dispatchClearDataAction(): void {
    this.storeRoot.dispatch(new ClearSubListAction());
  }

  dispatchToggleSelected(order: OrderItem): void {}

  // tslint:disable-next-line:no-any
  toggleSelected(data: any): void {
    this.storeRoot.dispatch(new ToggleSubListSelectionAction(data));
  }

  // tslint:disable-next-line:no-any
  routerLink(route: string , datas: any): {path: string[], fragment?: string} {
    const data = _.clone(datas);
    if (data && !data.clientUuid) {
      data.clientUuid = this.storeCurrentClient;
    }

    if (route === 'SubName' && data.siteUuid) {
      if (data.countSubscriptions && data.countSubscriptions > 1) {
        return {path: ['/', data.clientUuid, 'sites', 'detail-multi', data.siteUuid , data.subscriptionUuid], fragment: 'Subscription'};
      } else {
        if (data.subscriptionCount && data.subscriptionCount > 1) {
          return {path: ['/', data.clientUuid, 'sites', 'detail-multi', data.siteUuid , data.subscriptionUuid], fragment: 'Subscription'};
        }
        return {path: ['/', data.clientUuid, 'sites', 'detail', data.siteUuid], fragment: 'Subscription'};
      }
    }
    if (route === 'clientName' && data.clientUuid) {
      return {path: ['/', data.clientUuid, 'sites' , 'list']};
    }
    if (route === 'contractName' && data.siteUuid) {
      return {path: ['/', this.router.url.split('?')[0].split('/')[3] , 'contracts', 'detail', data.contractUuid], fragment: 'Contract'};
    }
    if (route === 'contractNameSub' && data.siteUuid) {

      return {path: ['/', data.companyUuid , 'contracts', 'detail', data.contractUuid], fragment: 'Contract'};
    }
    if (route === 'contractNameAnomalies' && data.companyUuid && data.contractUuid) {
      return {path: ['/', data.companyUuid , 'contracts', 'detail', data.contractUuid], fragment: 'Contract'};
    }
  }

  disablePagination(): boolean {
    return false;
  }

  // tslint:disable-next-line:no-any
  actionButton(type: string, data?: any): void {
    let typeLocal = true;
    this.sub$ =  this.storeCompany.pipe(select(fromCompanies.selectors.getCompany)).subscribe(company => {
      if (company && typeLocal) {
        this.companyName = company.name;
        this.companyUuid = company.uuid;
        const initial = {
          companyName: this.companyName,
          companyUuid: this.companyUuid,
        };
        // @ts-ignore
        this.bsModalRef = this.modalService.show(LinkContractModalComponent , { initial });
      }
    });
    this.subscriptions.push(this.sub$);
    typeLocal = false;
  }
  dispatchSelectPageAction(): void {
   if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
      this.storeRoot.dispatch(new SelectSubListPageSiteContextAction());
    } else {
      this.storeRoot.dispatch(new SelectSubListPageAction());
    }
  }


  initMenuItem():  MenuItem[] {

    this.menuItem = [];
    if (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'missingLink') {
      this.menuItem.push(
        new MenuItem('fad fa-link',
          'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
          'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
          'modal', null, null)
      );
    }
    else if (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'missingDelivery') {
      this.menuItem.push(
        new MenuItem('fa-shipping-fast fal',
          'ANOMALY_LIST_SET_DELIVERY',
          'ANOMALY_LIST_SET_DELIVERY',
          'modal', null, null )
      );
    }
    else if  (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'newSitesOff' ||
              this.activatedRoute.snapshot.queryParams['anomalyType'] === 'ToOffAndMissingBillingEnd') {
      this.menuItem.push(
        new MenuItem('fal fa-window-close',
          'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
          'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
          'modal', null, null , false , 'SUBSCRIPTION_END_DISABLED_IN_MENU')
      );
    } else if (this.dataConfig.mode !== 'anomaly') {

        this.menuItem.push(
          new MenuItem('fal fa-window-close',
            'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
            'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
            'modal', null, 'close', false, 'SUBSCRIPTION_END_DISABLED_IN_MENU')
        );

    //     if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
    //   this.menuItem.push(
    //     new MenuItem('fa fa-flag fa-fw',
    //       'GENERIC_CLOSE_SUBSCRIPTIONS',
    //       'GENERIC_CLOSE_SUBSCRIPTIONS',
    //       'modal', null, 'ReturnPlayer' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    //   );
    //   this.menuItem.push(
    //         new MenuItem('fal fa-building',
    //           'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //           'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //           'modal', null, 'MoveSubscription' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    //       );
    // }
        if (this.router.url.split('?')[0].split('/')[2] !== 'sites') {
        this.menuItem.push(
          new MenuItem('fad fa-link',
            'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
            'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
            'modal', null, 'link')
        );
      }
    }
    if  (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'NewSitesBillingEnd') {
      this.menuItem.push(
        new MenuItem('fa fa-flag fa-fw',
          'GENERIC_CLOSE_SUBSCRIPTION',
          'GENERIC_CLOSE_SUBSCRIPTION',
          'modal', null, 'ReturnPlayer' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
      );
      this.menuItem.push(
        new MenuItem('fal fa-building',
          'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
          'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
          'modal', null, 'MoveSubscription' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
      );
    }
    return this.menuItem;
  }



  showModal($event: MouseEvent, modal: any, data: any): void {// tslint:disable-line:no-any
    if (modal === 'linkAnomaliesSFInvoicesModal') {
      const initialState = {
        title: 'CONFIRMATION',
        message: 'Be careful this action will consider the whole client ' + data.clientName + ' as invoiced via Salesforce. Would you like to validate this choice?',
        variable: null,
        deleteBtn: false,
        hideBtnOk: true
      };
      this.bsModalRef = this.modalService.show(ModalComponent, { initialState });
      this.sub$ = combineLatest(this.modalService.onHide).subscribe(() => {
        if (this.bsModalRef.content.isConfirmed) {
           this.storeInvoices.dispatch(new IsSfInvoicedAction(data.clientUuid));
        }
      });
      this.subscriptions.push(this.sub$);
    }
    if (modal === 'ExploitWithBillingEnd') {
      this.router.navigate( ['/', data.clientUuid, 'sites', 'detail', data.siteUuid], {fragment: 'Subscription' } );
    }
    if ( modal === 'MultipleDefaultPlayer') {
      this.router.navigate( ['/', data.clientUuid, 'sites', 'detail', data.siteUuid], {fragment: 'Players' } );
    }
    if (modal === 'PriceZero') {
      this.router.navigate( ['/', data.companyUuid , 'contracts', 'detail', data.contractUuid],
        { fragment: 'Contract'});
    }
    if (modal === 'BlockedInvoicing') {
      this.router.navigate( ['/', 'companies', 'detail', data.companyUuid]);
    }
    if (modal === 'DeliveryModal') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data))
      this.bsModalRef = this.modalService.show(ManuallyCloseOrderComponent);
    }
    if (modal === 'linkModal') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data))
      const initialState = { contractName: data.name, contractUuid: data.uuid, productID: data.productID };
      this.bsModalRef = this.modalService.show(LinkContractModalComponent, { initialState });
    }
    if (modal === 'CloseSiteBillingModal') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data))
      this.bsModalRef = this.modalService.show(CloseBillingSubscriptionComponent);
    }
    if (modal === 'Exchange') {
      if ( data && data.siteUuid ) {
        this.router.navigate(['/', 'orders', 'add' , data.siteUuid]);
      }
      if ( this.activatedRoute.snapshot.routeConfig.path === 'detail-multi/:id' ) {

        this.router.navigate(['/', 'orders', 'add' , this.activatedRoute.snapshot.paramMap.get('id')]);
      } else {
        this.router.navigate(['/', 'orders', 'add' , data.Uuid]);
      }

    }
    if (modal === 'linkAnomaliesModal') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data))
      const initialState = { contractName: data.contractName, contractUuid: data.contractUuid, productID: data.productID };
      this.bsModalRef = this.modalService.show(LinkContractModalComponent, { initialState });
    }
    if (modal === 'NewSitesBillingEnd') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data));
      this.bsModalRef = this.modalService.show(AnomalyPlayerReturnComponent);
    }
    if (modal === 'MissingSAPCode') {
      this.storeRoot.dispatch(new SendEmailFinanceAction(data));
    }
    if (modal === 'ClientsMissingProject') {
      this.storeRoot.dispatch(new SelectOneItemSubListAction(data));
      this.bsModalRef = this.modalService.show(ModalEditSfProjectComponent);
    }
  }

  // tslint:disable-next-line:no-any
  updateStoreContextualMenu(data: any): void {
    // @ts-ignore
    if (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'missingLink') {
      this.bsModalRef = this.modalService.show(LinkContractModalComponent);
    }
    else if (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'missingDelivery') {
      this.bsModalRef = this.modalService.show(ManuallyCloseOrderComponent);
    }
    else if  (this.activatedRoute.snapshot.queryParams['anomalyType'] === 'newSitesOff' ||
      this.activatedRoute.snapshot.queryParams['anomalyType'] === 'ToOffAndMissingBillingEnd') {
      this.bsModalRef = this.modalService.show(CloseBillingSubscriptionComponent);
    } else {
      if (data === 'close') {
         this.bsModalRef = this.modalService.show(CloseBillingSubscriptionComponent);
      }
      if (data === 'link') {
        this.bsModalRef = this.modalService.show(LinkContractModalComponent);
      }
      if (data === 'INVOICES_MANAGEMENT') {
         this.bsModalRef = this.modalService.show(InvoicesManagementModalComponent);
        // console.log('updateStoreContextualMenu' , data)
      }
      if (data === 'ReturnPlayer') {
        this.bsModalRef = this.modalService.show(AnomalyPlayerReturnComponent);
      }

      if (data === 'MoveSubscription') {
        this.bsModalRef = this.modalService.show(MergeSiteDialogComponent);
      }

    }
  }
  checkStatus(value: SelectedItem[]): void {
    let first = true;
    let firstClientUuid;
    this.disableMenuEndBilling(false)
    this.disableClosePlayers(false)
    value.map(data => {
      if (data) {
        if (data.status === 1 &&
          (moment(data.end).year() !== new Date().getFullYear()) &&
          (moment(data.end).year() !== 2099) &&
          first) {
          this.disableMenuEndBilling(true);
        } else {
          first = false
          this.disableMenuEndBilling(false)
        }
        if (this.dataConfig.mode === 'anomaly') {
          this.disableMenuEndBilling(false);
        }
      }
      if (data) {
        if (!firstClientUuid) {
          firstClientUuid = data.clientUuid;
        } else {
          if (firstClientUuid !== data.clientUuid) {
            this.disableClosePlayers(true)
          }
        }
      }
      // this.cleanMenuItems();
      if (this.router.url.split('?')[0].split('/')[2] === 'sites') {
        if ((-1 !== _.findIndex(this.roles, ['code', 'BO_SETUP'])) &&
          (-1 === _.findIndex(this.roles, ['code', 'BO_BILLING_VIEW']))) {
          this.removeMenuEndBilling();
        }
        if (-1 !== _.findIndex(this.roles, ['code', 'BO_BILLING_VIEW']) &&
          (-1 === _.findIndex(this.roles, ['code', 'BO_SETUP']))) {
          this.removeMenuCloseSubscription();
        }
        if (-1 !== _.findIndex(this.roles, ['code', 'BO_BILLING_VIEW']) &&
          (-1 !== _.findIndex(this.roles, ['code', 'BO_SETUP']))) {
          this.addMenuCloseSubscriptionEndBilling();
        }
      }
    });
  }
  disableMenuCloseSubscription(value: boolean): void {
    if (this.menuItem) {
      this.menuItem.map(menuItem => {
        if (menuItem.icon === 'fa fa-flag fa-fw') {
          menuItem.disabled = value;
        }
      });

    }
  }

  removeMenuCloseSubscription(): void {
    this.menuItem = [];
    this.menuItem.push(
      new MenuItem('fal fa-window-close',
        'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
        'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
        'modal', null, 'close' , false , 'SUBSCRIPTION_END_DISABLED_IN_MENU')
    );
  }

  addMenuCloseSubscriptionEndBilling(): void {
    this.menuItem = [];
    this.menuItem.push(
      new MenuItem('fal fa-window-close',
        'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
        'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
        'modal', null, 'close' , false , 'SUBSCRIPTION_END_DISABLED_IN_MENU')
    );
    // this.menuItem.push(
    //   new MenuItem('fa fa-flag fa-fw',
    //     'GENERIC_CLOSE_SUBSCRIPTIONS',
    //     'GENERIC_CLOSE_SUBSCRIPTIONS',
    //     'modal', null, 'ReturnPlayer' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    // );
    // this.menuItem.push(
    //   new MenuItem('fal fa-building',
    //     'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //     'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //     'modal', null, 'MoveSubscription' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    // );
    this.menuItem.push(
      new MenuItem('fad fa-link',
        'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
        'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
        'modal', null, 'link')
    );

    this.menuItem.push(
      new MenuItem('fas fa-file-invoice-dollar',
        'CONTRACT_LINK_MODAL_INVOICES_MANAGEMENT',
        'CONTRACT_LINK_MODAL_INVOICES_MANAGEMENT',
        'modal', null, 'INVOICES_MANAGEMENT')
    );
  }

  cleanMenuItems(): void {
    this.menuItem = [];
  }

  removeMenuEndBilling(): void {
    this.menuItem = [];
    // this.menuItem.push(
    //   new MenuItem('fa fa-flag fa-fw',
    //     'GENERIC_CLOSE_SUBSCRIPTIONS',
    //     'GENERIC_CLOSE_SUBSCRIPTIONS',
    //     'modal', null, 'ReturnPlayer' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    // );
    // this.menuItem.push(
    //   new MenuItem('fal fa-building',
    //     'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //     'SITE_LIST_MERGE_SUBSCRIPTION_SITE',
    //     'modal', null, 'MoveSubscription' , null , 'SUBSCRIPTION_CLOSE_ANOMALIES_DISABLED_IN_MENU')
    // );
  }

  disableMenuEndBilling(value: boolean): void {

    if (this.menuItem) {
        this.menuItem.map(menuItem => {
          if (menuItem.icon === 'fal fa-window-close') {
            menuItem.disabled = value;
          }
        });

    }
  }
  disableClosePlayers(value: boolean): void {
    if (this.menuItem) {
      this.menuItem.map(menuItem => {

        if (menuItem.icon === 'fa fa-flag fa-fw') {
          menuItem.disabled = value;
        }
      });

    }
  }

  exportAsXLSX(): void {
    if (this.dataConfig.mode === 'anomaly') {
      this.storeRoot.dispatch(new ExportAnomalyTaskAction());
    }
     else if (this.dataConfig.mode === 'SiteSubscriptionList') {
      this.storeRoot.dispatch(new ExportClientSubscriptionAction());
    } else {
      this.storeRoot.dispatch(new ExportExcelAllSubAction());
    }
  }

}

